import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import { Landing } from "./components/Landing";
import { Register } from "./components/Register";
import { SignIn } from "./components/SignIn";
import { AccountCreated } from "./components/AccountCreated";
import { MediaAdded } from "./components/MediaAdded";
import { UserSettings } from "./components/UserSettings";
import { Footer } from "./components/Footer";
import { LinkSocial } from "./components/LinkSocial";
import { LinkTree } from "./components/LinkTree";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <div className="body">
          <LinkTree />
          <Route exact path="/" component={Landing} />
          <Route path="/register" component={Register} />
          <Route path="/sign-in" component={SignIn} />
          <Route path="/account-created" component={AccountCreated} />
          <Route path="/media-added" component={MediaAdded} />
          <Route path="/settings" component={UserSettings} />
          <Route path="/link-social" component={LinkSocial} />
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
